import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.textStrong};
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.textStrong};
`;

const CompanyInfo = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  
  p {
    margin-bottom: 0.5rem;
  }
`;

const Content = styled.div`
  font-size: 1rem;
  line-height: 1.7;

  h2 {
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem;
    color: ${({ theme }) => theme.textStrong};
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      bottom: -1px;
      left: 0;
      background-color: var(--primary);
      transition: width 0.3s ease;
    }
    
    &:hover {
      &:after {
        width: 100%;
      }
    }
  }
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.textStrong};
`;

const SubscriptionTerms = () => {
  return (
    <PolicyContainer>
      <Title>Subscription Terms</Title>
      <SubTitle>These Subscription Terms</SubTitle>
      <Content>
        <p>
          These Subscription Terms ("Subscription Terms") govern your use of the subscription services provided through the
          mobile application 1cal: AI Food Calorie Counter ("App"), operated by MYSTREAM LIMITED ("Company", "we", or "us").
          These Subscription Terms form an integral part of our Terms of Use: <a href="/terms">https://1cal.ai/terms</a>.
        </p>
        
        <Section>
          <SectionTitle>Subscription Options</SectionTitle>
          <p>1cal offers the following auto-renewable subscription plans:</p>
          <ul>
            <li>Monthly Plan: $7.99 per month</li>
            <li>Annual Plan: $34.99 per year - includes a 3-day free trial</li>
          </ul>
          <p>
            Note: Prices are valid for the United States. For other countries, prices are automatically converted and displayed in
            local currency by Apple or Google at checkout.
          </p>
          <p>
            A valid subscription provides unlimited access to all premium features available in the App, including all future updates
            and improvements, during the active subscription period.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>Free Trial</SectionTitle>
          <p>
            The annual plan includes a 3-day free trial. You may cancel at any time before the trial ends without being charged. If
            you do not cancel at least 24 hours before the trial period expires, your subscription will begin automatically, and you will
            be charged the full annual fee of $34.99.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>Payment & Auto-Renewal</SectionTitle>
          <ul>
            <li>Payment will be charged to your Apple ID or Google Play account upon purchase confirmation.</li>
            <li>Subscriptions automatically renew unless auto-renewal is turned off at least 24 hours before the end of the current
            billing cycle.</li>
            <li>Your account will be charged for renewal within 24 hours prior to the end of the current period.</li>
            <li>You are responsible for managing your subscription settings to avoid unwanted charges.</li>
          </ul>
        </Section>
        
        <Section>
          <SectionTitle>Managing Your Subscription</SectionTitle>
          <p>
            You can manage or cancel your subscription via your App Store (Apple) or Google Play account settings.
          </p>
          <p>
            Canceling an active subscription stops future billing but does not entitle you to a refund for the current billing period.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>Refund Policy</SectionTitle>
          <p>All payments are non-refundable.</p>
          <p>We do not provide partial or prorated refunds for unused subscription time.</p>
        </Section>
        
        <Section>
          <SectionTitle>Pricing & Feature Changes</SectionTitle>
          <p>
            Subscription pricing and available features may be subject to change in the future. Any updates will be communicated
            via the App or app store listing in advance. Continued use of the App after changes take effect constitutes your
            acceptance of the updated terms.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>Support</SectionTitle>
          <p>For support inquiries, please contact us at:</p>
          <p><a href="mailto:support@1cal.ai">support@1cal.ai</a></p>
        </Section>
        
        <Section>
          <SectionTitle>Company Information</SectionTitle>
          <CompanyInfo>
            <p><strong>MYSTREAM LIMITED</strong></p>
            <p><strong>Company number:</strong> HE423185</p>
            <p><strong>Registered address:</strong> Spirou Kyprianou, 78 MAGNUM BUSINESS CENTER, 3rd floor, 3076, Limassol, Cyprus</p>
            <p>Incorporated in accordance with the laws of the Republic of Cyprus.</p>
          </CompanyInfo>
        </Section>
      </Content>
    </PolicyContainer>
  );
};

export default SubscriptionTerms; 